export default {
  'profile.name': 'Nhập',
  'profile.title': 'Nhập',
  'profile.info': 'Thông tin cá nhân',
  'profile.edit': 'Chỉnh sửa thông tin',
  'profile.code.title': 'Mã code không đúng',
  'profile.code.content': 'Bạn có muốn quay về để đăng nhập lại',
};
